import { render, staticRenderFns } from "./productsCompact.vue?vue&type=template&id=97d63d76&scoped=true&"
import script from "./productsCompact.vue?vue&type=script&lang=js&"
export * from "./productsCompact.vue?vue&type=script&lang=js&"
import style0 from "./productsCompact.vue?vue&type=style&index=0&id=97d63d76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d63d76",
  null
  
)

export default component.exports